// extracted by mini-css-extract-plugin
module.exports = {"bookReader":"LitresReader_bookReader__M3Z5O","book-reader-iframe":"LitresReader_book-reader-iframe__9bSJl"};